import * as React from 'react';
import Modal from '../../core/ui/modal';
import Tabs from '../../core/ui/tabs';
import Grid, { Col } from '../../core/ui/grid';
import { connect } from 'react-redux';
import { actions as homeActions } from '../../actions/home.actions';
import LoginForm from './parts/login.form';
import SignUpForm from './parts/signup_form';
import Icon from 'src/core/ui/icon';
import {IApplicationState, UserType} from "../../typings";

export interface LoginProps {
    visible: boolean;
    selectedPrompt: number;
    preferedRole?: UserType;
}

export interface LoginState {
  visible: boolean;
  verificationOpen: boolean;
}

export class Login extends React.Component<LoginProps & typeof homeActions, LoginState> {
  
  constructor(props: any) {
    super(props);

    this.state = {
      visible: false,
      verificationOpen: false,
    }
  }

  public componentWillReceiveProps(nextProps: LoginProps){
    this.setState({visible: nextProps.visible});
  }
  

  public render() {

    return (
      <React.Fragment>
        
        <Modal
            closable
            onCancel={() => this.setState({verificationOpen: false})}
            size='complete'
            closeOnDimmer
            className='fixed'
            visible={this.state.verificationOpen}
            type={'dark'}
        >

            <div className='verification-message'>
              <Grid centered>
                <Col className='center-vertical' size={13}>

                  <div className='iconified wire wire-1 light scale-3 not-mobile'>
                      <Icon  type='envelop'/>
                  </div>
                </Col>
                <Col size={40}>
                <h1 style={{maxWidth:'300px', minWidth: 'unset'}}>
                    E-mail Verification
                </h1>

                  <div style={{display: 'flex'}} className='iconified wire wire-1 light scale-2 mobile'>
                      <Icon  type='envelop'/>
                  </div>
                <p style={{maxWidth: '400px'}}>
                We sent you an e-mail with a link to complete your registration.
                </p>
                </Col>
              </Grid>
                
            </div>
        </Modal>

          <Modal
          type='dark'
          closable
          size='complete'
          className='fixed '
          closeOnDimmer
          onCancel={
            () => {
              this.setState({visible: false})
              this.props.toggleLogin(false, 0, undefined);
            }
          }
          visible={this.state.visible}
        >
        <Tabs
          titles={["Login", 'Sign up']}
          selectedIndex={this.props.selectedPrompt}
          bodies={[
            <LoginForm {...this.props} />, 
            <SignUpForm
              preferedRole={this.props.preferedRole}
              onSuccessfullSignUp={() => this.setState({verificationOpen: true})}
            {...this.props}/>]}
        />
        </Modal>

      </React.Fragment>
    );
  }
}

function mapStateToProps(state: IApplicationState, props: LoginProps){
    return {
        ...props,
        visible: state.loginModal.open,
        selectedPrompt: state.loginModal.openIn,
        preferedRole: state.loginModal.preferedRole
    }
}

export default connect(mapStateToProps, {...homeActions})(Login);


// WEBPACK FOOTER //
// ./src/components/login/login.tsx